import React from 'react'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import DarkModeIcon from '@mui/icons-material/DarkMode'
import GridViewIcon from '@mui/icons-material/GridView'
import LightModeIcon from '@mui/icons-material/LightMode'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import NotesIcon from '@mui/icons-material/Notes'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import { Link, useParams } from 'react-router'
import DeviceLogsContent from '../components/DeviceLogsContent'
import cnergiLogo from '../resources/CNERGI_PNG@4x.png'
import { getLoginSession } from '../services/authApi'
import './DashboardPage.css'
import './DashboardLogsPage.css'

function getDisplayName(user = {}) {
  const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ')

  return user.fullName || user.name || fullName || 'User'
}

function DashboardLogsPage({ isDarkMode = false, onSelectTheme }) {
  const { deviceId = '' } = useParams()
  const displayName = getDisplayName(getLoginSession()?.user)
  const dashboardPath = deviceId ? `/dashboard/${encodeURIComponent(deviceId)}` : '/dashboard'

  return (
    <main className="old-dashboard old-dashboard--logs-page">
      <section className="old-dashboard__shell old-dashboard__shell--logs" aria-label="CNERGI device logs dashboard">
        <aside className="old-dashboard__sidebar">
          <a className="old-dashboard__brand" href="/" aria-label="CNERGI home">
            <img src={cnergiLogo} alt="CNERGI" />
          </a>

          <p className="old-dashboard__menu-label">menu</p>

          <nav className="old-dashboard__nav" aria-label="Dashboard navigation">
            <Link className="old-dashboard__nav-button" to={dashboardPath} aria-label="Dashboard" title="Dashboard">
              <GridViewIcon aria-hidden="true" />
            </Link>
            <button className="old-dashboard__nav-button old-dashboard__nav-button--active" type="button" aria-label="Logs" title="Logs">
              <NotesIcon aria-hidden="true" />
            </button>
            <Link className="old-dashboard__nav-button" to="/maindash" aria-label="Back to main dashboard" title="Back to main dashboard">
              <ArrowBackIcon aria-hidden="true" />
            </Link>
          </nav>

          <a className="old-dashboard__support" href="#support" aria-label="Support">
            <SupportAgentIcon aria-hidden="true" />
          </a>
        </aside>

        <section className="old-dashboard__main old-dashboard__main--logs-page" aria-labelledby="old-dashboard-logs-title">
          <header className="old-dashboard__header">
            <h1 id="old-dashboard-logs-title">{deviceId ? `Logs ${deviceId}` : 'Logs'}</h1>

            <div className="old-dashboard__header-actions">
              <button
                className="old-dashboard__theme-toggle"
                type="button"
                aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
                onClick={() => onSelectTheme?.(isDarkMode ? 'light' : 'dark')}
              >
                {isDarkMode ? <LightModeIcon aria-hidden="true" /> : <DarkModeIcon aria-hidden="true" />}
              </button>

              <div className="old-dashboard__user">
                <AccountCircleIcon aria-hidden="true" />
                <strong>{displayName}</strong>
              </div>

              <button className="old-dashboard__more" type="button" aria-label="More options">
                <MoreVertIcon aria-hidden="true" />
              </button>
            </div>
          </header>

          <section className="old-dashboard__logs-page-panel" aria-label="Device logs">
            <div className="old-dashboard__logs-page-heading">
              <span>CNERGI Device Logs</span>
              <p>Device ID: {deviceId || 'No device selected'}</p>
            </div>
            <DeviceLogsContent deviceId={deviceId} />
          </section>
        </section>
      </section>
    </main>
  )
}

export default DashboardLogsPage
